import './js/index';
import './sass/style.scss';